export default __webpack_public_path__ + "static/poweredByLogo-a513854c34febf398b65242886125f6f.svg";